import React, { FC, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
import { Theme } from "@mui/system";

import StepItem from "./components/StepItem/StepItem";
import { StyledStepper, StyledConnector } from "./Steps.styled";
import AddStep from "./components/AddStep";

import { useMultistepFormStore } from "@components/common/MultistepForm";

const Steps: FC = () => {
  const isDesktop = useMediaQuery<Theme>(({ breakpoints }) => breakpoints.up("md"));
  const {
    filteredSections,
    formSettings: { editMode },
  } = useMultistepFormStore();

  const content = useMemo(
    () =>
      filteredSections
        .filter((section) => section.isVisible)
        .map((section, index) => (
          <StepItem
            key={`step-${section.id}`}
            section={section}
            sectionIndex={index}
          />
        )),
    [filteredSections],
  );

  return (
    <StyledStepper
      nonLinear
      orientation={isDesktop ? "vertical" : "horizontal"}
      connector={<StyledConnector />}
    >
      {content}
      {editMode && <AddStep />}
    </StyledStepper>
  );
};

export default Steps;
